import axios from "../../../axiosConfig/axios";
// get Product details
    export const getDetailsProduct = async (token,id)=>{    
        return await axios.post(`getMarketPlace`,
        {
            details:"true",id:id, searchingkeyword:"", filteration:"", limit:1,offset:0
        },
        {
            headers:{
                'Content-Type':'application/json',
                Authorization:token,
            }
        }
        )}
        // product api
    export const productsApi = {
        async getProductsPage(token, offset, searchingkeyword, filteration, limit=30, details=false){
        if((searchingkeyword) || (Object.keys(filteration)?.length > 0) ){
                {
                    return await axios.post(`getMarketPlace`,
                        {
                            details:details, offset:0, limit:0, searchingkeyword, filteration:filteration
                        },{
                            headers:{
                                'Content-Type':'application/json',
                                Authorization:token,
                            }
                        }
                        )
                    }
            }
            else{
                {
                    return await axios.post(`getMarketPlace`,
                        {
                            details:details, offset:offset, limit:limit, searchingkeyword:searchingkeyword, filteration:filteration
                        },{
                            headers:{
                                'Content-Type':'application/json',
                                Authorization:token,
                            }
                        }
                        )
                    }
            }
        }
    }